import { input, Signal, TemplateRef, viewChild } from '@angular/core';

export abstract class PanelViewBase {
  abstract name: Signal<string>;
  abstract label: Signal<string | undefined>;
  abstract icon: Signal<string | undefined>;
  abstract template: Signal<TemplateRef<any> | undefined>;
}
